var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDownDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    opacity: 0.3,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01234 25.7C8.76484 25.733 8.58334 25.667 8.33584 25.5845C7.41184 25.271 6.96634 24.281 7.24684 23.357C7.52734 22.4495 8.89684 18.341 8.89684 17.45C8.89684 16.5755 7.65934 15.8 6.66934 15.8H1.71934C0.729336 15.8 0.0693359 15.14 0.0693359 14.15C0.0693359 13.16 3.36934 2.60001 3.36934 2.60001C3.64984 1.95651 4.27684 0.950012 5.01934 0.950012H20.1003V15.8H16.5693C15.8928 16.4765 11.1243 23.5715 10.6623 24.4955C10.3158 25.172 9.67234 25.6175 9.01234 25.7ZM26.7003 15.8H23.4003V0.950012H26.7003V15.8Z",
    fill: "#709CC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownDisabled);
export default __webpack_public_path__ + "static/media/thumbs-down-disabled.a33d367bf8ace6d7c518f7a679be7e66.svg";
export { ForwardRef as ReactComponent };